import React from 'react'

const SocialIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 20C0 8.9543 8.95431 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
      fill="#FF9900"
    />
    <path
      d="M29.5833 19.5833C29.5833 15.2179 25.2845 11.6667 20 11.6667C14.7154 11.6667 10.4166 15.2179 10.4166 19.5833C10.4166 23.9488 14.7154 27.5 20.0058 27.5C20.8597 27.4879 21.7107 27.3958 22.5475 27.225L27.3458 29.1371C27.4127 29.1637 27.4854 29.1725 27.5568 29.1626C27.6282 29.1528 27.6957 29.1246 27.753 29.0808C27.8102 29.037 27.8551 28.9792 27.8832 28.9129C27.9114 28.8465 27.9219 28.7741 27.9137 28.7025L27.4379 24.5775C28.7845 23.2615 29.5558 21.4661 29.5833 19.5833ZM23.1162 20.3971L23.1 20.4133L20.2641 23.2242C20.1934 23.2941 20.0979 23.3333 19.9985 23.3333C19.8991 23.3333 19.8036 23.2941 19.7329 23.2242L16.8975 20.4138C16.6937 20.2121 16.5316 19.9723 16.4205 19.7081C16.3094 19.4438 16.2515 19.1602 16.25 18.8736C16.2485 18.5869 16.3034 18.3028 16.4117 18.0373C16.52 17.7719 16.6796 17.5304 16.8812 17.3267L16.8975 17.3104C17.3094 16.9037 17.8632 16.6729 18.4421 16.6668C19.0209 16.6606 19.5795 16.8796 20 17.2775C20.4203 16.8799 20.9786 16.6611 21.5572 16.6672C22.1357 16.6732 22.6893 16.9037 23.1012 17.31C23.3049 17.5117 23.4669 17.7516 23.5778 18.0159C23.6888 18.2802 23.7467 18.5638 23.7481 18.8504C23.7495 19.1371 23.6944 19.4212 23.586 19.6866C23.4775 19.952 23.3179 20.1934 23.1162 20.3971Z"
      fill="white"
    />
  </svg>
)

export default SocialIcon
